export default __webpack_public_path__ + "static/media/ChainSafe-logo.17ac7e66.png";